import { Component, OnInit, Input } from '@angular/core';
import { trigger, transition, useAnimation } from '@angular/animations';
import { fadeInDown } from 'ng-animate';
import { FormBuilder, FormGroup, Validators, FormControl, AbstractControl, FormGroupDirective } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { ApirequestService } from '../../../../services/apirequest/apirequest.service';
import { ApiurlsService } from '../../../../services/api-urls/apiurls.service';
import { UtilityService } from '../../../../services/utilities/utilities.services';

declare var $: any;

@Component({
  selector: 'hybse-admin-company-edit',
  templateUrl: './company-edit.component.html',
  styleUrls: ['./company-edit.component.css'],
  animations: [
    trigger('fadeInDown', [transition('* => *', useAnimation(fadeInDown, {
      params: {
        timing: 1,
        a: '-10px'
      }
    }))])
  ],
})
export class CompanyEditComponent implements OnInit {

  constructor(private _fb: FormBuilder,
    private _req: ApirequestService,
    private _urls: ApiurlsService,
    private _utils: UtilityService,
    private route: ActivatedRoute,
    private router: Router) { }

  fadeInDown: any;
  newsID: any = '';
  newsUpdateForm: FormGroup;
  newsDetails: any;
  alertStatusMessage: boolean = false;
  formResponseMsg: string = '';
  showLoader: boolean = false;
  userName: any = '';

  compUpdateFormInit() {
    this.newsUpdateForm = this._fb.group({
      'title': [''],
      'href': ['']
    });
  }

  getNewsDetails() {
    let data = { idExchangeNews: this.newsID };
    let url = this._urls.compDetailUrl;
    this._req.fetchApiData(url, data).subscribe(
      (data: any) => {
        let response = data.data;
        if (response !== '') {
          this.newsDetails = response;
          this.setFormData(this.newsDetails);
        }
      },
      error => {

      },
      () => {

      }
    )
  }

  updateNewsDetails() {
    const newsVal = this.newsUpdateForm.value;
    this.showLoader = true;
    let data = {
      title: newsVal.title,
      href: newsVal.href,
      idExchangeNews: this.newsID
    };

    this._req.fetchApiData(this._urls.companyUpdateUrl, data).subscribe(
      (data: any) => {
        console.log('News', data);
        let res = data.data;
        if (res !== '') {
          this.showLoader = false;
          this.getUserFormStat({ status: true, message: 'News has been Updated' });
          this.router.navigate(['/news/lists']);
        }
      }
    );
  }

  setFormData(data) {
    this.newsUpdateForm.patchValue({
      title: data.title,
      href: data.href
    });
  }

  cancelNewsUpdate() {
    this.router.navigate(['/news/lists']);
  }

  getUserFormStat(e) {
    this._utils.scrollToY(0, 400, 'easeInOutQuint');
    this.alertStatusMessage = e.status;
    this.formResponseMsg = e.message;
    setTimeout(() => {
      $('.alert_messages').fadeOut('400', () => {
        setTimeout(() => {
          this.alertStatusMessage = false;
        }, 1000);
      });
    }, 3000);

  }

  ngOnInit() {
    this.compUpdateFormInit();
    this.route.params.subscribe(
      params => {
        this.newsID = params.id;
        this.getNewsDetails();
      }
    );
  }

  displayCounter(value) {
    if (value) {
      this.getNewsDetails();
    }
  }
}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/company/edit/company-edit.component.ts